import React from 'react'
import { BrowserRouter } from 'react-router-dom'
import { Ripple } from '@progress/kendo-react-ripple'
import { IntlProvider } from '@progress/kendo-react-intl'

import AppHeader from './components/layouts/AppHeader'
import Routing from './Routing'
import { CommonActions, useAppDispatch } from './stores'
import { InitialDataLoader, Localizer } from './services'
import { Loading } from './components/layouts/Loading'
import { useApplicationInsightsUserTelemetry } from './Insights'

Localizer.loadResources()

export default function App() {
  const dispatch = useAppDispatch()

  React.useEffect(() => {
    InitialDataLoader.load()
      .then(initialData => {
        dispatch(CommonActions.setInitialData(initialData))
      })
      .finally(() => {})
  }, [])

  useApplicationInsightsUserTelemetry()

  return (
    <IntlProvider locale='ja'>
      <BrowserRouter>
        <Ripple>
          <div className="container">
            <div className="header">
              <AppHeader />
            </div>
            <div className="body">
              <Routing />
            </div>
            <Loading/>
          </div>
        </Ripple>
      </BrowserRouter>
    </IntlProvider>
  )
}
